import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import {Block_Tenant, Unblock_Tenant} from '../Tenant_API'

interface propDataType {
  id: string | undefined
  tenantDetails: any
  get_view_tenant: any
  dateSuperScript: any
}
const ViewTenant = ({id, tenantDetails, get_view_tenant, dateSuperScript}: propDataType) => {
  const location = useLocation()
  const [tenantStatusLoading, setTenantStatusLoading] = useState(false)
  const handleBlock = async () => {
    setTenantStatusLoading(true)
    if (id) {
      const {data: res} = await Block_Tenant(id)
      if (res.code === '200') {
        get_view_tenant()
        setTenantStatusLoading(false)
      }
    }
  }
  const handleUnBlock = async () => {
    setTenantStatusLoading(true)
    if (id) {
      const {data: res} = await Unblock_Tenant(id)
      if (res.code === '200') {
        get_view_tenant()
        setTenantStatusLoading(false)
      }
    }
  }
  return (
    <>{
      tenantDetails && 
      <div className='card mb-5 mb-xl-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol bg-light-primary symbol-100px symbol-lg-160px symbol-fixed position-relative'>
              <iframe
                width='200px'
                src='https://embed.lottiefiles.com/animation/78355'
                title='tenant profile'
              ></iframe>
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {tenantDetails?.accouont_holder_name.charAt(0).toUpperCase() +
                      tenantDetails?.accouont_holder_name.slice(1)}
                  </span> 
                  <span>
                    {tenantStatusLoading ? (
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    ) : tenantDetails?.tenant_account_status === 1 ? (
                      <i
                        className='bi bi-patch-check-fill fs-2 text-success'
                        title='Tenant is unblocked'
                      ></i>
                    ) : (
                      <i
                        className='bi bi-patch-exclamation-fill fs-2 text-danger'
                        title='Tenant is blocked'
                      ></i>
                    )}
                  </span>
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <span className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                    {tenantDetails?.property_usage_type === 1 ? ( 
                      <>
                    <i className='bi bi-house-door' />Residential Tenant</>
                     ) : (
                      <>
                          <i className='bi bi-building'></i>Commercial Tenant</>
                        )}
                  </span>
                  <span className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                    <i className='bi bi-telephone'></i>
                    {tenantDetails?.contact_number}
                  </span>
                  <span className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'>
                    <i className='bi bi-envelope'></i>
                    {tenantDetails?.email_id}
                  </span>
                </div>
              </div>

              <div className='d-flex my-4'>
                <button
                  className='btn btn-sm btn-primary me-3'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_offer_a_deal'
                  onClick={tenantDetails?.tenant_account_status === 1 ? handleBlock : handleUnBlock}
                  disabled={tenantStatusLoading}
                >
                  {tenantStatusLoading ? (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Processing...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : tenantDetails?.tenant_account_status === 1 ? (
                    'Block'
                  ) : (
                    'Unblock'
                  )}
                </button>
              </div>
            </div>

            <div className='d-flex flex-wrap flex-stack'>
              <div className='d-flex flex-column flex-grow-1 pe-8'>
                <div className='d-flex flex-wrap'>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-4 fw-bolder'>{`${
                        tenantDetails?.currency_code === 'INR' ? '₹' : tenantDetails?.currency_code
                      } ${tenantDetails?.property_rent_rate}`}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Rent Rate</div>
                  </div>

                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-4 fw-bolder'>{`${
                        tenantDetails?.currency_code === 'INR' ? '₹' : tenantDetails?.currency_code
                      } ${tenantDetails?.security_deposit}`}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>security deposit</div>
                  </div>

                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-4 fw-bolder'><span>{`By ${tenantDetails?.property_rent_due_date}`}</span><sup>{dateSuperScript(tenantDetails?.property_rent_due_date)}</sup></div>
                    </div>
                    <div className='fw-bold fs-6 text-gray-400'>Rent Due Date</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === `/tenant/${id}/overview` && 'active')
                }
                to='overview'
              >
                Overview
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  (location.pathname === `/tenant/${id}/documents` && 'active')
                }
                to='documents'
              >
                Documents
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    }
    </>
  )
}

export default ViewTenant
